export { default } from './FormSharedAccess.vue'
